import { useMemo } from 'react';

import { EnvironmentCountries, MultilingualCodeSystems } from '@e-origin/shared';

import { isHighValueDeclaration } from '@utils';
import { useSettings } from './useSettings';

export interface UseCodeListSystemParams {
  group?: string;
  isExport?: boolean;
  isTransit?: boolean;
}

export const useCodeListSystem = (params: UseCodeListSystemParams): MultilingualCodeSystems[] => {
  const { data: settings } = useSettings();
  const { group, isExport = false, isTransit = false } = params;

  return useMemo(() => {
    if (isTransit) return [MultilingualCodeSystems.NCTSP5];

    const systems: MultilingualCodeSystems[] = [];
    systems.push(isExport ? MultilingualCodeSystems.AES : MultilingualCodeSystems.CCI);

    const isHighValue = isHighValueDeclaration(group);
    if (isHighValue && settings?.country === EnvironmentCountries.BE) {
      systems.push(isExport ? MultilingualCodeSystems.AESBE : MultilingualCodeSystems.IDMS);
    } else if (isHighValue && settings?.country === EnvironmentCountries.NL) {
      systems.push(isExport ? MultilingualCodeSystems.AESNL : MultilingualCodeSystems.DMS);
    }

    return systems;
  }, [group, isExport, isTransit, settings?.country]);
};
